/** Accepts any number of arbitrarily typed parameters, and does nothing. */
export function noop(..._args: unknown[]): void {
  return;
}
